export default __webpack_public_path__ + "static/media/(6).1bb4d13d.jpeg";